import { Injectable } from '@angular/core';


@Injectable()
export class SharedConstants {
  static networkErrorMessage = 'Sorry, it seems you are offline. Please check your internet connectivity.';


}



// WEBPACK FOOTER //
// ./src/services/shared/shared-constants.ts